import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CarritoService } from 'src/app/services/carrito.service';
import { FirestoreService } from 'src/app/services/firestore.service';

interface MenuItem {
  title: string;
  icon: string;
  link?: string;
  action?: () => void;
  show?: () => boolean;
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  menuItems: MenuItem[] = [];

  constructor(
    public auth: AuthService,
    private firestore: FirestoreService,
    private router: Router,
    private carritoSv: CarritoService
  ) {}

  ngOnInit() {
    this.initAuthListener();
  }

  openWhatsapp() {
  window.open('https://wa.me/+34641612226', '_blank');
}

  // 🔐 Escucha cambios de sesión
  initAuthListener() {
    this.auth.stateAutho().subscribe(res => {
      if (res) {
        this.auth.uid = res.uid;

        this.firestore.getDoc('users', res.uid).subscribe(user => {
          this.auth.user = user;
          this.buildMenu(); // 🔥 reconstruir menú
        });

      } else {
        this.auth.user = null;
        this.auth.uid = null;
        this.buildMenu(); // 🔥 reconstruir menú
      }
    });
  }

  // 🧠 Construcción dinámica del menú
buildMenu() {
  this.menuItems = [
    {
      title: 'Carrito',
      icon: 'carrito.svg',
      link: '/carrito'
    },
    {
      title: 'Tienda',
      icon: 'storefront-outline',
      link: '/selectGenero'
    },
    {
      title: 'Mujeres',
      icon: 'storefront-outline',
      link: '/estilo/mujeres'
    },
    {
      title: 'Hombres',
      icon: 'storefront-outline',
      link: '/estilo/hombres'
    },
    {
      title: 'Configuración',
      icon: 'create',
      link: '/set-productos',
      show: () => this.auth.user?.admin
    },

    // 👤 Usuario
    {
      title: 'Perfil',
      icon: 'person-circle-outline',
      link: '/perfil',
      show: () => !!this.auth.user
    },
    {
      title: 'Mis pedidos',
      icon: 'receipt-outline',
      link: '/pedidos',
      show: () => !!this.auth.user
    },

    // 🔐 Admin
    {
      title: 'Pedidos (Admin)',
      icon: 'albums-outline',
      link: '/allpedidos',
      show: () => this.auth.user?.admin
    },

    // 🌐 Acción externa
    {
      title: 'WhatsApp',
      icon: 'logo-whatsapp',
      action: () => this.openWhatsapp()
    },

    // 🔓 Auth
    {
      title: 'Registrarse',
      icon: 'person-add-outline',
      link: '/singup',
      show: () => !this.auth.user
    },
    {
      title: 'Iniciar sesión',
      icon: 'log-in-outline',
      link: '/singin',
      show: () => !this.auth.user
    },
    {
      title: 'Cerrar sesión',
      icon: 'log-out-outline',
      action: () => this.logout(),
      show: () => !!this.auth.user
    }
  ];
}

  // 🚪 Logout limpio
  async logout() {
    await this.auth.logout();
    this.auth.user = null;
    this.auth.uid = null;

    this.carritoSv.initCart();
    this.buildMenu(); // 🔥 actualizar menú

    this.router.navigate(['/']);
  }
}
